/* global Loader:true $:true Foundation:true Flickity:true */
//import 'babel-polyfill';
import debug from "debug";

window.Symbol = Symbol;
const ONE = 1;
// const ZERO = 0;
const MODULE_NAME = 'module/product-index';
const log = debug(MODULE_NAME);

$(document).ready(() => {
    const attrNameGroupItem = 'data-filter-group';
    const attrNameGroupReset = 'data-resets-filter-group';

    $(`[${attrNameGroupItem}]`)
        .not(`[${attrNameGroupReset}]`)
        .on('click', function (event, element) {
            let filterGroupName = $(this).attr('data-filter-group');
            log(`enableFilterItem: ${filterGroupName}`);
            $(`[data-resets-filter-group][data-filter-group="${filterGroupName}"]`)
                .attr({checked: false});
        });

    $(`[${attrNameGroupItem}][${attrNameGroupReset}]`)
        .on('click', function (event) {
            log(this, event.target, 'clicked');
            let filterGroupName = $(this).attr('data-filter-group');
            log(`resetGroup: ${filterGroupName}`);
            $(`[data-filter-group="${filterGroupName}"]`)
                .not($(this))
                .attr({checked: false});
        });

});



// WEBPACK FOOTER //
// ./project/client/src/scripts/module.product-index.js